<template>
  <a
    class="telegram-button"
    rel="noopener noreferrer"
    target="_blank"
    :href="link"
    :style="style"
  >
    {{content}}
  </a>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';

export default {
  mixins: [aboutMixin],
  computed: {
    style() {
      return `width: ${this.width}px; height: ${this.height}px;`;
    },
  },
  data() {
    return {
      content: '',
    };
  },
  props: {
    /**
     * @description ссылка на телеграм
     * @type string
     */
    link: {
      type: String,
      default: aboutMixin.supportTelegramHref,
    },
    /**
     * @description Высота
     * @type String
     */
    height: {
      type: String,
      default: '24',
    },
    /**
     * @description Ширина
     * @type String
     */
    width: {
      type: String,
      default: '22',
    },
  },
};

</script>

<style scoped lang="scss">
  .telegram-button {
    flex-shrink: 0;
    background: no-repeat url("@/assets/img/social/telegram-blue.svg") 50%;
    background-size: contain;
    &:hover  {
      filter: brightness(95%) contrast(100%);
    }
  }
</style>
